import renderElement from './element';

export default renderElement.bind(null, 'div');


// WEBPACK FOOTER //
// ../~/idom-util/src/div.js